/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Session_Hard_Limit_LongInputs */

const en_us2_intake_why_session_hard_limit_long = /** @type {(inputs: Intake_Why_Session_Hard_Limit_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A hard limit trims isolation work first. A soft one lets a session run over on a good day.`)
};

const pt_br2_intake_why_session_hard_limit_long = /** @type {(inputs: Intake_Why_Session_Hard_Limit_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um limite rígido corta isolamento primeiro. Um flexível deixa passar num dia bom.`)
};

const es_419_intake_why_session_hard_limit_long = /** @type {(inputs: Intake_Why_Session_Hard_Limit_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un límite estricto recorta primero los ejercicios de aislamiento. Uno flexible deja que la sesión se alargue en un buen día.`)
};

const pt_pt2_intake_why_session_hard_limit_long = /** @type {(inputs: Intake_Why_Session_Hard_Limit_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um limite rígido corta primeiro o trabalho de isolamento. Um flexível deixa a sessão prolongar-se num dia bom.`)
};

const fr_fr2_intake_why_session_hard_limit_long = /** @type {(inputs: Intake_Why_Session_Hard_Limit_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une limite stricte coupe d'abord l'isolation. Une limite souple laisse une séance déborder un bon jour.`)
};

const de_de2_intake_why_session_hard_limit_long = /** @type {(inputs: Intake_Why_Session_Hard_Limit_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine feste Grenze kürzt zuerst Isolationsübungen. Eine weiche lässt eine Einheit an einem guten Tag länger laufen.`)
};

const it_it2_intake_why_session_hard_limit_long = /** @type {(inputs: Intake_Why_Session_Hard_Limit_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un limite rigido taglia prima gli esercizi di isolamento. Uno flessibile lascia sforare la sessione in una giornata buona.`)
};

/**
* | output |
* | --- |
* | "A hard limit trims isolation work first. A soft one lets a session run over on a good day." |
*
* @param {Intake_Why_Session_Hard_Limit_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_session_hard_limit_long = /** @type {((inputs?: Intake_Why_Session_Hard_Limit_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Session_Hard_Limit_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_session_hard_limit_long(inputs)
	if (locale === "es-419") return es_419_intake_why_session_hard_limit_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_session_hard_limit_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_session_hard_limit_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_session_hard_limit_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_session_hard_limit_long(inputs)
	return en_us2_intake_why_session_hard_limit_long(inputs)
});
export { intake_why_session_hard_limit_long as "intake.why.session_hard_limit.long" }